import { GridColDef } from "@mui/x-data-grid";
import {
  renderClaimTypeIcon,
  renderDateWithoutTime,
  renderStatusIcon,
} from "../helpers";

export const columns: GridColDef[] = [
  {
    field: "claimType",
    headerName: "Claim type",
    flex: 1,
    headerAlign: "center",
    headerClassName: "super-app-theme--header",
    align: "center",
    minWidth: 100,
    cellClassName: "super-app-theme--cell",
    renderCell: (params) => renderClaimTypeIcon(params.value) ?? "-",
  },
  {
    field: "incidentDate",
    headerName: "Incident Date",
    flex: 1,
    headerClassName: "super-app-theme--header",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => renderDateWithoutTime(params.value) ?? "-",
  },
  {
    field: "matchIndividual",
    headerName: "Individual",
    flex: 1,
    headerClassName: "super-app-theme--header",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchAliasOrID",
    headerName: "Alias or ID",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchEmailAddress",
    headerName: "Email Address",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchDrivingLicenseNumber",
    headerName: "Driving License",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchNationalInsuranceNumber",
    headerName: "NI",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchPassportNumber",
    headerName: "Passport number",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchPhoneNumber",
    headerName: "Phone Number",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchAddress",
    headerName: "Address",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchOrganisation",
    headerName: "Organisation",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
  {
    field: "matchVehicle",
    headerName: "Vehicle",
    flex: 1,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
    minWidth: 100,
    renderCell: (params) => renderStatusIcon(params.value),
  },
];
export default columns;
